import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'

const SPONSORED_LABEL_STYLE = { color: '#767676' }

function SponsoredLabel() {
  const intl = useIntl()

  const label = intl.formatMessage({
    id: 'DBOvmzwulU0OVx0hPGqK',
    defaultMessage: 'Ad',
    description: 'Disclosure label shown on a search tile when the offer is a sponsored placement',
  })

  return <BodyText as="span" variant="small" weight="normal" style={SPONSORED_LABEL_STYLE}>
    {label}
  </BodyText>
}

export default SponsoredLabel
